<template>
    <div>
        <div class="submitted-message" v-if="formIsSend">
            <i class="fas" :class="[sendFormIcon, {'move-left-animation': sendFormIcon===sendFormIcons[2]}]"></i>
            <v-button @click="refreshForm" label="Отправить еще"/>
        </div>
        <div class="feedback-form" v-else>
            <h3>Нужна помощь?</h3>
            <form :class="{ 'form-shake': formIsShaking }" @submit.prevent="sendFeedBack">
                <p class="error" v-show="formHasErrors">{{errorMessage}}</p>
                <text-input
                        input-id="1"
                        input-type="email"
                        placeholder="Ваш email"
                        v-model="feedBack.email"
                        :error="formHasErrors"
                />
                <text-input
                        input-id="2"
                        placeholder="Опишите вашу проблему"
                        v-model="feedBack.message"
                        :as-text-area="true"
                        :rows="10"
                        :error="formHasErrors"
                />
                <v-button label="Отправить" />
            </form>
        </div>
    </div>
</template>

<script>
  import vButton from "../components/vButton";
  import TextInput from "./form_components/TextInput";
  import { FeedBackAPI } from "api-client";

  export default {
    name: "FeedBackForm",
    components: {
      vButton,
      TextInput
    },
    props:{
      formIsOpened: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        formIsShaking: false,
        errorMessage: "",
        formIsSend: false,
        sendFormIcons: [
          'fa-envelope-open',
          'fa-envelope-open-text',
          'fa-envelope'
        ],
        sendFormIcon: 'fa-envelope-open',
        feedBack: {
          email: "",
          message: ""
        }
      };
    },
    computed: {
      formHasErrors() {
        return this.errorMessage.length > 0;
      },
      fieldsIsEmpty() {
        return this.feedBack.message === "" || this.feedBack.email === "";
      }
    },
    methods: {
      async sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
      },
      async runSendingAnimation() {
        this.sendFormIcon = this.sendFormIcons[0]
        for (const el of this.sendFormIcons) {
          this.sendFormIcon = el
          await this.sleep(700)
        }
      },
      shakeForm() {
        this.formIsShaking = true;
        window.setTimeout(() => (this.formIsShaking = false), 100);
      },
      async sendFeedBack() {
        if (this.fieldsIsEmpty) {
          this.errorMessage = "Оба поля должны быть заполнены";
          this.shakeForm();
        } else {
          const formData = new FormData();
          formData.set("email", this.feedBack.email);
          formData.set("message", this.feedBack.message);
          try {
            this.formIsSend = true
            FeedBackAPI.sendFeedBack(formData).then();
            for (let i=0; i<3; i++) {
                await this.runSendingAnimation()
            }
            this.callSubmitEmmit()
            this.refreshForm()
          } catch (e) {
            window.console.log(e)
          }
        }
      },
      callSubmitEmmit() {
        this.$emit('submitted')
      },
      refreshForm() {
        this.formIsSend = false
        this.errorMessage = ''
        this.sendFormIcon = this.sendFormIcons[0]
        this.feedBack = {
          email: '',
          message: ''
        }
      }
    }
  };
</script>

<style>
    @keyframes run {
        0% { margin-left: 0;}
        100%{
            margin-left: 150px;
            opacity: 0;
        }
    }
</style>

<style lang="sass" scoped>
    @import '../assets/sass/animations'

    .submitted-message
        overflow: hidden
        position: relative
        height: 387px
        flex-direction: column
        display: flex
        justify-content: center
        align-items: center

    .submitted-message
        i
            position: absolute
            top: 70px
            font-size: 150px
            margin-bottom: 20px
        button
            position: absolute
            bottom: 50px

    .move-left-animation
        margin-top: 18px
        animation: run 1s infinite

    .feedback-form
        height: 387px
        h3
            margin-top: 0


    .form-shake
        animation: shake 100ms
</style>
